import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { CHECK_USER_CAN_BE_ADMIN, GET_LOGOUT_TOKEN } from "../../services/Api";

export const checkAdminUsers = createAsyncThunk(
  "checkAdminUsers",
  async ({ emailId, token }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${CHECK_USER_CAN_BE_ADMIN}/${emailId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error checking admin user:", error);
      return rejectWithValue(error.response?.data || error?.message || "Error checking admin user");
    }
  }
);

export const logOutToken = createAsyncThunk("logOutToken", async (token, { rejectWithValue }) => {
  try {
    const response = await axios.post(
      GET_LOGOUT_TOKEN,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error Getting Logout Token:", error);
    return rejectWithValue(error.response?.data || "Error Getting Logout Token");
  }
});

const fetchAllUsersSlice = createSlice({
  name: "allUsers",
  initialState: {
    isLoading: false,
    data: null,
    isError: false,
    errorMessage: "",
  },
  extraReducers: (builder) => {
    builder.addCase(checkAdminUsers.pending, (state) => {
      state.isLoading = true;
      state.errorMessage = "";
    });
    builder.addCase(checkAdminUsers.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(checkAdminUsers.rejected, (state, action) => {
      // eslint-disable-next-line no-console
      console.error("error", action.payload);
      state.isError = true;
      state.errorMessage = action.payload;
    });
    builder.addCase(logOutToken.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(logOutToken.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(logOutToken.rejected, (state, action) => {
      // eslint-disable-next-line no-console
      console.error("error", action.payload);
      state.isError = true;
    });
  },
});

export default fetchAllUsersSlice.reducer;
